import React, { useEffect, useState } from 'react';
import { FaCalendarAlt } from 'react-icons/fa'; 
import '../styles/CardStyles.css';

function AveragePostsPerMonthCard() {
  const [averagePosts, setAveragePosts] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/data`);
        const data = await response.json();

        if (!data || !Array.isArray(data)) {
          console.error('Nenhum dado válido foi retornado da API');
          return;
        }

        const postsPerMonth = {};

        data.forEach(post => {
          const postDate = new Date(post._source.data_postagem);
          const monthYear = `${postDate.getMonth() + 1}-${postDate.getFullYear()}`;

          if (!postsPerMonth[monthYear]) {
            postsPerMonth[monthYear] = 0;
          }
          postsPerMonth[monthYear]++;
        });

        const totalMonths = Object.keys(postsPerMonth).length;
        const totalPosts = Object.values(postsPerMonth).reduce((acc, count) => acc + count, 0);

        const average = totalPosts / totalMonths;
        setAveragePosts(average.toFixed(2)); 
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="card">
      <FaCalendarAlt size={40} color="#5a7302" className="card-icon" /> 
      <h3>Média de Postagens por Mês</h3>
      <p>{averagePosts}</p>
    </div>
  );
}

export default AveragePostsPerMonthCard;
